import React from 'react';
//components
import { ActionTagContainer } from './styles';
//interfaces
import { IActionTag } from './interface';

export const ActionTag: React.FC<IActionTag> = (props) => {
  const { tagTitle, onClick, hasMarginLeft = false } = props;

  return (
    <ActionTagContainer onClick={onClick} hasMarginLeft={hasMarginLeft}>
      {tagTitle}
    </ActionTagContainer>
  );
};